import { ReactNode } from 'react';
import styled from 'styled-components';
import { Tooltip } from 'ui/tooltip/Tooltip';
import { colors } from 'ui/theme/colors';

const IconButton = styled.div`
  color: ${colors.brandPurple};
  cursor: pointer;
  display: flex;
`;

export const testIds = {
  button: 'url-input-icon-button',
};

export type Props = {
  'data-test'?: string;
  className?: string;
  onClick: () => void;
  tooltipContent: string;
  Icon: ReactNode;
};

export const UrlInputIconButton = ({
  'data-test': dataTest = testIds.button,
  className,
  onClick,
  tooltipContent,
  Icon,
}: Props) => {
  return (
    <Tooltip tooltipContent={tooltipContent} className={className}>
      <IconButton data-test={dataTest} onClick={onClick}>
        {Icon}
      </IconButton>
    </Tooltip>
  );
};
